import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

//ModalPos, ModalGal, ModalHSlide, ModalMSlide
import ModalPos from "./ModalPos";
import ModalGal from "./ModalGal";
import ModalRead from "./ModalRead";
import ModalHSlide from "./ModalHSlide";
import ModalMSlide from "./ModalMSlide";
import ModalFaq from "./ModalFaq";
import ModalCat from "./ModalCat";
import ModalPag from "./ModalPag";


import ModalPostStaff from "./ModalPostStaff";
import ModalMessage from "./ModalMessage";
import ModalUpdateStaff from "./ModalUpdateStaff";
import PrintDoc from "../appComponents/PrintDoc";

const Modal = (props) => {
  // Encrypt Decrypt Data //
  const encrypt = (encrypDycrypData, type) => {
    let result;
    if (type === "Encrypt") {
      result = window.btoa(encrypDycrypData);
    } else if (type === "Decrypt") {
      result = window.atob(encrypDycrypData);
    }
    return result;
  };

  let PATH = window.location.origin;

  const [closeModal, setCloseModal] = useState(false);

  const closeModalRef = useRef();

  let tagName;

  switch (props.modalType) {

case "ModalMSlide":
      tagName = (
        <ModalMSlide
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
          modalTitle={props.titles}
          btnColors={props.btnColor}
        />
      );
      break;

    case "ModalMSlidePrintout":
      tagName = (
        <PrintDoc
          docType={"ModalMSlidePrintout"}
          title={"MANAGEMENT SLIDE PRINT OUT"}
          id={props.editpost}
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/VerifyMSlidePrintout?payload=" +
            encrypt(props.searchScript, "Encrypt")
          }
        />
      );
      break;

      case "ModalHSlide":
      tagName = (
        <ModalHSlide
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
          modalTitle={props.titles}
          btnColors={props.btnColor}
        />
      );
      break;

    case "ModalHSlidePrintout":
      tagName = (
        <PrintDoc
          docType={"ModalHSlidePrintout"}
          title={"HOMEPAGE SLIDE PRINT OUT"}
          id={props.editpost}
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/VerifyHSlidePrintout?payload=" +
            encrypt(props.searchScript, "Encrypt")
          }
        />
      );
      break;


      case "ModalGal":
      tagName = (
        <ModalGal
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
          modalTitle={props.titles}
          btnColors={props.btnColor}
        />
      );
      break;

    case "ModalGalPrintout":
      tagName = (
        <PrintDoc
          docType={"ModalGalPrintout"}
          title={"GALLERY PRINT OUT"}
          id={props.editpost}
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/VerifyGalPrintout?payload=" +
            encrypt(props.searchScript, "Encrypt")
          }
        />
      );
      break;

      case "ModalPos":
      tagName = (
        <ModalPos
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
          modalTitle={props.titles}
          btnColors={props.btnColor}
        />
      );
      break;

    case "ModalPosPrintout":
      tagName = (
        <PrintDoc
          docType={"ModalPosPrintout"}
          title={"POST PRINT OUT"}
          id={props.editpost}
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/VerifyPosPrintout?payload=" +
            encrypt(props.searchScript, "Encrypt")
          }
        />
      );
      break;


    case "ModalRead":
      tagName = (
        <ModalRead
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
          reloadCharts={props.reloadChart}
          modalTitle={props.titles}
          btnColors={props.btnColor}
        />
      );
      break;

    case "ModalReadPrintout":
      tagName = (
        <PrintDoc
          docType={"ModalReadPrintout"}
          title={"GALLERY PRINT OUT"}
          id={props.editpost}
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/VerifyGalPrintout?payload=" +
            encrypt(props.searchScript, "Encrypt")
          }
        />
      );
      break;






    case "ModalFaq":
      tagName = (
        <ModalFaq
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
          modalTitle={props.titles}
          btnColors={props.btnColor}
        />
      );
      break;

    case "ModalFaqPrintout":
      tagName = (
        <PrintDoc
          docType={"ModalFaqPrintout"}
          title={"FAQ PRINT OUT"}
          id={props.editpost}
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/VerifyFaqPrintout?payload=" +
            encrypt(props.searchScript, "Encrypt")
          }
        />
      );
      break;

      case "ModalCat":
      tagName = (
        <ModalCat
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
          modalTitle={props.titles}
          btnColors={props.btnColor}
        />
      );
      break;

    case "ModalCatPrintout":
      tagName = (
        <PrintDoc
          docType={"ModalCatPrintout"}
          title={"CATEGORY PRINT OUT"}
          id={props.editpost}
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/VerifyCatPrintout?payload=" +
            encrypt(props.searchScript, "Encrypt")
          }
        />
      );
      break;

      case "ModalPag":
      tagName = (
        <ModalPag
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
          modalTitle={props.titles}
          btnColors={props.btnColor}
        />
      );
      break;

    case "ModalPagPrintout":
      tagName = (
        <PrintDoc
          docType={"ModalPagPrintout"}
          title={"WEBPAGE PRINT OUT"}
          id={props.editpost}
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/VerifyPagPrintout?payload=" +
            encrypt(props.searchScript, "Encrypt")
          }
        />
      );
      break;

    /////////////////////////////////////////////////////////////////////

    

    case "ModalUsersSheet":
      tagName = (
        <PrintDoc
          docType={"ModalUsersSheet"}
          title={"Staff Data"}
          id={props.editpost}
          datesUseds={props.searchDate}
          referenceNo={
            PATH +
            "/verifystaffsheet?payload=" +
            encrypt(props.searchScript, "Encrypt")
          }
        />
      );
      break;

    case "ModalPostStaff":
      tagName = (
        <ModalPostStaff
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
        />
      );
      break;
    case "ModalUpdateStaff":
      tagName = (
        <ModalUpdateStaff
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
        />
      );
      break;

    case "ModalStaffIDCard":
      tagName = (
        <PrintDoc
          docType={"ModalStaffIDCard"}
          title={"Staff ID Card"}
          id={props.editpost}
          referenceNo={
            PATH +
            "/verifystaffidcard?payload=" +
            encrypt(props.editpost.fileNumber, "Encrypt")
          }
        />
      );
      break;

    case "ModalBulkStaffIDCard":
      tagName = (
        <PrintDoc
          docType={"ModalBulkStaffIDCard"}
          title={"Staff ID Card"}
          id={props.editpost}
          referenceNo={
            PATH +
            "/verifystaffidcard?payload=" +
            encrypt(props.editpost.fileNumber, "Encrypt")
          }
        />
      );
      break;

    default:
      tagName = (
        <ModalMessage
          editposts={props.editpost}
          setCloseModal={setCloseModal}
          formCleanners={props.formCleanner}
        />
      );
  }

  if (closeModal === true) {
    closeModalRef.current?.click();
    props.formCleanner();
    setCloseModal(false);
  }

  return props.trigger ? (
    <>
      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {props.titles}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                ref={closeModalRef}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="container-lg-fluid m-3">{tagName}</div>
            </div>
            <div className="modal-footer">
              <Link
                type="button"
                className="btn btn-secondary"
                to="#"
                data-dismiss="modal"
                ref={closeModalRef}
              >
                Close
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    ""
  );
};

export default Modal;
